module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjBAMAAAB9FaOmAAAALVBMVEXcGB7cGB79FQ6eHTwALJIAKokAKocAC5qJk0b//wD97A5KpkQAhlwWklMWklMga4ZpAAAAD3RSTlPx///z+v///e/9//P///GlrSadAAAAPUlEQVR4AWJiIBkwCZIKBADt1DENAAAMAkH/rmuhYSMc+4XtgxcEQcZIXph2opYIgugYgiCvIdKHIMhexw6GLS81Uh0HuwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Mauritius.png
// module id = 594
// module chunks = 0